export default () => {
  $(document).on("dp_variation", function(e, data) {
    let {description} = data

    $('.p-product-description').html(description)
  });
}
